import { render, staticRenderFns } from "./fichaClienteB2C.vue?vue&type=template&id=761f9e49"
import script from "./fichaClienteB2C.vue?vue&type=script&lang=js"
export * from "./fichaClienteB2C.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports